import moment from "moment";
import toast from "react-hot-toast";
import { logoutUser } from "../apiCalls/authApi";

/***************************
 * Common Utilities
 ***************************/

export const numberWithCommas = (number) => {
    if (number) {
        // Remove any commas if the input is a string
        const cleanedNumber = typeof number === 'string' ? number.replace(/,/g, '') : number;
        return Number(cleanedNumber).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        return "0.00";
    }
}
export const formatAmount = (number) => {
    if (number) {
        // Remove any commas if the input is a string
        const cleanedNumber = typeof number === 'string' ? number.replace(/,/g, '') : number;
        return Number(cleanedNumber).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } else {
        return "0.00";
    }
}

export const refreshPage = () => {
    window.location.reload();
};

export const getTime = (date) => {
    return date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    });
};

export const subtractMonths = (numOfMonths, date = new Date()) => {
    date.setMonth(date.getMonth() - numOfMonths);
    return date.toISOString().split("T")[0];
};

export const getTodayDate = () => {
    return new Date();
};

export const getTodayDateISO = () => {
    let deets = new Date();
    let date = deets.toLocaleString("en-US", { timeZone: "Asia/Manila" });
    return moment(date).format("yyyy-MM-DD");
};

export const getAge = (dateString) => {
    var today = new Date();
    var birthdate = new Date(dateString);
    var age = today.getFullYear() - birthdate.getFullYear();
    var m = today.getMonth() - birthdate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
        age--;
    }
    return age;
};

export const formatDate = (date) => {
    var formatDate = new Date(date);
    var stringDate = formatDate.toDateString().split(" ");

    return (
        stringDate[1] +
        " " +
        stringDate[2] +
        ", " +
        stringDate[3] +
        " " +
        formatDate.toLocaleTimeString().replace(/(.*)\D\d+/, "$1")
    );
};

export const formatDateSeconds = (date) => {
    var formatDate = new Date(date);
    var stringDate = formatDate.toDateString().split(" ");

    return (
        stringDate[1] +
        " " +
        stringDate[2] +
        ", " +
        stringDate[3] +
        " " +
        formatDate.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")
    );
};

export const formatDateNoTime = (date) => {
    var formatDate = new Date(date);
    var stringDate = formatDate.toDateString().split(" ");

    return stringDate[1] + " " + stringDate[2] + ", " + stringDate[3];
};

export const formatDateSlash = (date) => {
    var stringDate = date.split("-");

    return stringDate[1] + "/" + stringDate[2] + "/" + stringDate[0];
};

export const formatDateSlashWithTime = (date) => {
    var formatDate = new Date();
    var stringDate = formatDate.split("-");

    return (
        stringDate[1] +
        "/" +
        stringDate[2] +
        "/" +
        stringDate[3] +
        "/" +
        formatDate.toLocaleTimeString()
    );
};

export const formatMDY = (date) => {
    var stringDate = date.split("-");
    return stringDate[1] + "-" + stringDate[2] + "-" + stringDate[0];
};

export const validateUsername = (username) => {
    if (username === "") {
        return true;
    } else {
        var filter =
            /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
        return String(username).search(filter) != -1;
    }
};

export const isClosingTime = (time) => {
    var format = "hh:mm:ss";
    var endTime = moment(time, format);
    return moment().isAfter(endTime);
};

export const isNotClosingDate = (date) => {
    return moment().isBefore(moment(date).add(1, "d"));
};

export const validateContact = (num) => {
    var mobileFilter =
        /(^0|[89]\d{2}-\d{3}-?\d{4}$)|(^0|[89]\d{2}\d{3}\d{4}$)|(^63[89]\d{2}-\d{3}-\d{4}$)|(^63[89]\d{2}\d{3}\d{4}$)|(^[+]63[89]\d{2}\d{3}\d{4}$)|(^[+]63[89]\d{2}-\d{3}-\d{4}$)/;
    var telFilter = /^[0-9]+(-[0-9]+)+$/;

    if (
        String(num).search(mobileFilter) != -1 ||
        String(num).search(telFilter) != -1
    ) {
        return true;
    } else {
        return false;
    }
};

export const dateFormat = (date) => {
    return moment(date).format("MMM DD, YYYY");
};

export const formatYDM = (date) => {
    return moment(date).format("YYYY-MM-DD");
};

export const numberFormat = (data) => {
    return parseFloat(data).toLocaleString(undefined, {
        minimumFractionDigits: 2,
    });
};
export const formatPrice = (amount) => {
    switch (typeof amount) {
        case "number":
            return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        case "string":
            if (amount === "" || amount === "0.00") {
                return "0.00";
            } else {
                return parseFloat(amount)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
            }
    }
};

export const formatNum = (num) => {
    return parseFloat(Math.round(num * 100) / 100).toFixed(2);
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const TokenExpiry = async (error) => {
    if (error.error.status === 401 || error.status === 401) {
        const response = await logoutUser();
        toast.loading("Token has expired. Logging you out...", {
            style: toastStyle(),
        });
        removeUserSession();
        setTimeout(() => refreshPage(), 1000);
    }
};

/***************************
 * Local Storage Utilities
 ***************************/

//return user data from local storage
export const getUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

export const getFullNameUser = () => {
    const userStr = localStorage.getItem("full_name");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

//return user name from local storage
export const getName = () => {
    const userStr = localStorage.getItem("name");
    if (userStr!=="") return JSON.parse(userStr);
    else return null;
};

//return user type from local storage
export const getRole = () => {
    const userStr = localStorage.getItem("role_id");
    if (userStr) return JSON.parse(userStr);
    else return null;
};
//return user type from local storage
export const getItemDiscountType = () => {
    const userStr = localStorage.getItem("item_discount_type");
    if (userStr) return JSON.parse(userStr);
    else return null;
};
//return user type from local storage
export const getItemDiscountAmount = () => {
    const userStr = localStorage.getItem("amount_to_be_discounted");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

//return role type from local storage
export const getPermissions = () => {
    const userStr = localStorage.getItem("permissions");
    if (userStr) return JSON.parse(userStr);
    else return null;
};
export const removeUserSession = () => {
    localStorage.clear();
};
//return user role from local storage
export const getAPIKey = () => {
    const userStr = localStorage.getItem("api-key");
    if (userStr) return userStr;
    else return null;
};

//return token from local storage
export const getToken = () => {
    const userStr = localStorage.getItem("token");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

//return token from local storage
export const getZReading = () => {
    const userStr = localStorage.getItem("zreading");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

export const getOrderID = () => {
    const userStr = localStorage.getItem("order_id");
    if (userStr) return JSON.parse(userStr);
    else return null;
};
//return table id/user id from local storage
export const getTableID = () => {
    const userStr = localStorage.getItem("idUser");
    if (userStr !== "undefined" && userStr != null) return JSON.parse(userStr);
    else return "";
};

// export const getOrderID = () => {
//     const userStr = localStorage.getItem("orderId");
//     if (userStr !== "undefined" && userStr != null) return JSON.parse(userStr);
//     else return "";
// };

export const getContactUser = () => {
    const userStr = localStorage.getItem("contactNUser");
    if (userStr) return JSON.parse(userStr);
    else return null;
};

//remove user details from local storage
// export const removeUserSession = () => {
//     localStorage.removeItem("user");
//     localStorage.removeItem("name");
//     localStorage.removeItem("type");
//     localStorage.removeItem("role");
//     localStorage.removeItem("api-key");
//     localStorage.removeItem("token");
// };
export const removeOrderId = () => {
    localStorage.removeItem("order_id");
};
export const removePaymentId = () => {
    localStorage.removeItem("payment_id");
};
// toast style
export const toastStyle = () => {
    return {
        fontFamily: "Made-Tommy-Soft-Regular",
        borderRadius: "10px",
        background: "#333",
        color: "#fff",
    };
};
export const isEmptyString = (text) => {
    if (text) {
        const tempText = text.toString();
        return tempText.trim()===""
    } return false;
}